import { Component, Prop, VNode, h } from '@stencil/core';
import { Hyperlink, getHyperLinkObject } from '../../../core/interfaces/Hyperlink';
import { Theme } from '../../../core/types/globalTypes';
import { isNullOrUndefined } from 'utils/collection';

/**
 * @hidden
 */
@Component({
  tag: 'ads-breadcrumb',
  styleUrl: 'ads-breadcrumb.scss',
  shadow: true,
})
export class AdsBreadCrumb {
  /**
   * The theme for this component instance (optional)
   * Values: "default", "dark"
   */
  @Prop({ reflect: true }) theme?: Theme;

  /**
   * Defines an aria-current attribute for the component (optional)
   * @default false
   */
  @Prop({ reflect: true }) current = false;

  /**
   * Contains a URL (fragment).
   * If this property is set, an anchor tag will be rendered (optional)
   */
  @Prop({ reflect: true }) link?: Hyperlink;

  /**
   * Defines an aria-label attribute for the component (optional)
   */
  @Prop({ reflect: true }) srLabel?: string;

  protected render(): VNode {
    const linkObj = getHyperLinkObject(this.link);
    const TagType = !isNullOrUndefined(linkObj) ? 'a' : 'span';

    const baseClass = !isNullOrUndefined(linkObj) ? 'c-breadcrumb__anchor' : null;
    const classes = [baseClass];

    const attributes = {
      href: linkObj?.href,
      hrefLang: linkObj?.hreflang || null,
      rel: linkObj?.rel || null,
      target: linkObj?.target || null,
      'aria-label': this.srLabel,
      'aria-current': this.current ? 'page' : null,
      'data-track': 'true',
      'data-track-value': this.srLabel,
      onClick: linkObj?.onClick || null,
    };

    return (
      <TagType class={classes.join(' ')} {...attributes}>
        <slot />
      </TagType>
    ) as VNode;
  }
}
